import React from 'react';
import { useSelector, useDispatch } from 'react-redux';

import Message from './Message';
import CardOutline from '../CardOutline';
import GetLinkCard from '../GetLinkCard';

import { webCommunityOperations } from '@evdy/web-redux/dist/lib/webCommunity';

import styles from './Messages.module.scss';

import shareMessageIcon from '../../public/images/icons/Share-Memories-Color-Icon.png';

const { showMoreMessages } = webCommunityOperations;

const {
  messages: messagesClass,
  'view-more': viewMoreClass,
  'section-title': sectionTitleClass,
  'no-messages-card': noMessagesClass,
  'no-msg-title': noMsgTitleClass,
  'no-msg-subtitle': noMsgSubtitleClass
} = styles;

const msgIncrementAmount = 10;

const NoMessages = () => (
  <CardOutline customClass={noMessagesClass}>
    <img src={shareMessageIcon} alt="share-message" />
    <div className={noMsgTitleClass}>There are no messages yet</div>
    <div className={noMsgSubtitleClass}>
      When people reply to the invitation, you'll find their messages here.
    </div>
  </CardOutline>
);

const Messages = ({ baseRoute }) => {
  const dispatch = useDispatch();
  const { messages, messagesShown, userName } = useSelector(({ webCommunity, authUser }) => ({
    messages: webCommunity.messages?.array,
    messagesShown: webCommunity.messages?.messagesShown,
    userName: authUser?.data?.name
  }));
  const isHidingMessages = messages?.length > messagesShown;

  const handleShowMore = () => {
    dispatch(showMoreMessages({ msgIncrementAmount }));
  };

  const sortedMessages = [...messages].sort((a, b) => (a.createdAt < b.createdAt ? 1 : -1));
  const firstMessage = sortedMessages[0] ?? {};

  return (
    <div className={messagesClass}>
      {!sortedMessages.length ? (
        <>
          <NoMessages />
          <GetLinkCard borderless />
        </>
      ) : (
        <>
          <Message
            displayMode
            key={firstMessage._id}
            {...{ ...firstMessage, userName }}
            messageDetailUrl={`${baseRoute}/messages/${firstMessage._id}`}
          />
          <GetLinkCard borderless />
          {sortedMessages.slice(1, messagesShown).map(message => (
            <Message
              displayMode
              key={message._id}
              {...{ ...message, userName }}
              messageDetailUrl={`${baseRoute}/messages/${message._id}`}
            />
          ))}
          {isHidingMessages && (
            <button className={viewMoreClass} onClick={handleShowMore}>
              View 10 more messages
            </button>
          )}
        </>
      )}
    </div>
  );
};

export default Messages;
